export default {
  getPetImageURL(chat) {
    if (!chat || !chat.pet || !chat.pet.imageId) return '%23';
    return `${process.env.VUE_APP_API_URL}/chat/${chat.chatId}/image/${chat.pet.imageId}/pet?token=${localStorage.jwtToken}`;
  },
  getProfileImageURL(imageId) {
    if (!imageId) return '%23';
    return `${process.env.VUE_APP_API_URL}/public/profile/image/${imageId}`;
  },
  getMessageImage(chat, imageId) {
    if (!chat || !chat.chatId || !imageId) return '%23';
    return `${process.env.VUE_APP_API_URL}/chat/${chat.chatId}/image/${imageId}?token=${localStorage.jwtToken}`;
  },
  getPractitionerName(practitioners, message) {
    const prac = practitioners.find((practitioner) => practitioner.practitionerId === message.userId);
    if (!prac || !prac.name) {
      return "Tuntematon";
    }
    return prac.name; 
  },
  mapSpecies(species) {
    if (species === 'dog') {
      return 'Koira';
    } else if (species === 'cat') {
      return 'Kissa';
    } else {
      return "Laji ei tidossa";
    }
    //return species;
  },
  mapGender(pet) {
    if (pet.gender === 'male') {
      return 'Uros';
    } else if (pet.gender === 'female' && pet.species === 'cat') {
      return 'Naaras';
    } else if (pet.gender === 'female' && pet.species === 'dog') {
      return 'Narttu';
    }
    return '';
  },
  sendNotification(options, message) {
    if(Notification && Notification.permission === 'granted') {
      new Notification(message, options);
      var myAudio = new Audio('/notification/appointed.mp3');
      var promise = myAudio.play();
      if (promise !== undefined) {
        promise.then(() => {
          myAudio.play();
        }).catch(error => {
          //could not play sound
          console.log(error);
        });
      }
    } else {
      Notification.requestPermission();
    }
  },
};
